/** @type {import('tailwindcss').Config} */
const config = {
  content: ['./ds/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      backgroundImage: () => ({
        'cult-gradient': 'linear-gradient(110deg, #68655D 0%, #150F02 100%)',
        'article-gradient':
          'linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 86.46%)',
        'repeating-slanted-lines':
          'repeating-linear-gradient(135deg, #F2F4F7, #F2F4F7 2px, #F2F4F700 2px, #F2F4F700 10px)',
        'telehealth-background': "url('/Background.png')",
        'round-telehealth-loader':
          'linear-gradient(90deg, #EAEDF1 1.04%, rgba(234, 237, 241, 0.00) 122.92%), linear-gradient(90deg, #EAEDF1 1.04%, rgba(234, 237, 241, 0.00) 122.92%), linear-gradient(90deg, #EAEDF1 1.04%, rgba(234, 237, 241, 0.00) 122.92%)',
        'retail-green-gradient':
          'linear-gradient(180deg, #FFF 0%, #F1FFFB 100%)',
        'retail-purple-gradient-mobile':
          'linear-gradient(0deg, #FFF 77%, #C7B1C0 84%, rgba(58, 14, 43, 0.90) 93%, #3A0E2B 100%)',
        'retail-purple-gradient-laptop':
          'linear-gradient(0deg, #FFF 73%, #C7B1C0 76%, rgba(58, 14, 43, 0.90) 90%, #3A0E2B 100%)',
        'rtl-bot-button': 'linear-gradient(91deg, #F0FFFC 0%, #FFFAE6 100%)',
        'ask-plum-ai-button': 'linear-gradient(91deg, #EBF3FF 0%, #FFF 100%)',
        'white-gradient':
          'linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)',
        'retail-progress-gradient':
          'linear-gradient(90deg, #F2FBFF 0%, #FAFFF9 100%)',
        'retail-percent-coupon-gradient':
          'linear-gradient(180deg, #F5FFFE 0%, #FFF 21.64%)',
        'retail-fixed-coupon-gradient':
          'linear-gradient(180deg, #F9FBFF 0%, #FFF 20.73%)',
      }),
      fontFamily: {
        chromatica: 'Chromatica, ui-sans-serif',
        body: 'Inter, Chromatica',
      },
      maxWidth: {
        'plum-xs': '256px',
        'plum-sm': '300px',
        'plum-800': '800px',
      },
      height: {
        105: '420px',
      },
      colors: {
        primary: {
          50: '#FDEDEF',
          100: '#FCDCDF',
          200: '#F8B9BF',
          300: '#F5959E',
          400: '#F1727E',
          500: '#EE4F5E',
          600: '#BE3F4B',
          700: '#8F2F38',
          800: '#5F2026',
          900: '#301013',
        },
        hero: {
          vision: {
            500: '#400F31',
          },
        },
        coral: '#E06358',
        beach: {
          50: '#FCF6EB',
          100: '#FAEEDA',
        },
        promise: {
          100: '#FEFAF3',
        },
        secondary: {
          50: '#F9F8F6',
          100: '#F2F0ED',
          200: '#ECE9E5',
          300: '#E5E1DC',
          400: '#DBD6CE',
          500: '#CCC4BA',
          600: '#CCC4BA',
          700: '#928B82',
          800: '#5B5752',
          900: '#4A4642',
        },
        yellow: {
          50: '#FCE9B8',
          100: '#FCE9B8',
          200: '#FFDE9E',
          500: '#FFCB52',
          600: '#F7931E',
        },
        green: {
          100: '#F3FFDA',
        },
        cream: {
          50: '#FFEED2',
        },
        gray: {
          100: '#F3EEE5',
          200: '#878787',
          250: '#2B2B2B',
          500: '#55657D',
          400: '#8C98AB',
          600: '#2D3D54',
          700: '#203248',
          800: '#182639',
        },
        'gray-border': {
          100: '#F3EEE5',
          200: '#E0E0E0',
        },
        teal: {
          100: '#EBFEFA',
          200: '#E6FFFA',
          300: '#6CA193',
          500: '#4E9594',
          600: '#41797A',
          700: '#355D60',
          800: '#234E52',
          900: '#1D4044',
          benefit: {
            100: '#B2F5EA',
          },
        },
        surface: {
          100: '#FAF8F5',
        },
        orange: {
          accent: '#FFFBF1',
        },
        brand: {
          gray: { 100: '#EAEDF1' },
          vision: {
            100: '#F2E5ED',
            300: '#570E40',
          },
          highlight: {
            clear: {
              200: '#E7F5FF',
              300: '#429CD8',
            },
          },
        },
        feedback: {
          positive: {
            intense: '#15803D',
            subtle: '#F0FDF4',
          },
        },
        mobile: {
          hero: {
            100: '#EE4F5E',
            600: '#2F0C25',
          },
          primary: {
            10: '#FFF8F3',
            100: '#FFF2E8',
            200: '#FFE0CC',
            500: '#EE4F5E',
            600: '#D44C46',
          },
          gray: {
            50: '#F2F4F7',
            100: '#EAEDF1',
            200: '#E1E5EB',
            300: '#C5CCD6',
            400: '#8C98AB',
            500: '#55657D',
            600: '#2D3D54',
            700: '#203248',
          },
          teal: {
            10: '#E0F1F1',
            50: '#EBFEFA',
            500: '#478978',
            600: '#407B6C',
          },
          accent: {
            error: '#D04954',
            initiated: '#724364',
            failed: '#EF4444',
          },
          beach: {
            100: '#FEEEC4',
            300: '#F8D49B',
          },
          text: {
            main: '#203248',
            hierarchy: {
              1: '#63707F',
              2: '#798491',
            },
          },
          border: {
            gray: {
              100: '#F3EEE5',
              200: '#E0E0E0',
            },
          },
        },
        'mobile-text': {
          main: '#203248',
          text2: '#8C7385',
          hierarchy: '#63707F',
          hierarchy2: '#798491',
          disabled: '#828282',
        },
        plum: {
          blue: {
            1: '#D5ECFC',
          },
        },
        retail: {
          primary: {
            50: '#EFFEFA',
            100: '#CAFDF2',
            200: '#9FFCE9',
            300: '#57F1D8',
            400: '#25DCC3',
            500: '#0CBDA8',
            600: '#079A8C',
            700: '#0A7B71',
            800: '#0D625B',
            900: '#10514B',
          },
          gray: {
            50: '#F9FAFB',
            100: '#EAEDF1',
            200: '#E1E5EB',
            300: '#C5CCD6',
            400: '#8C98AB',
            500: '#55657D',
            600: '#2D3D54',
            700: '#203248',
            800: '#182639',
            900: '#000A26',
          },
          red: {
            50: '#FDF3F3',
            100: '#FBE6E5',
            200: '#F9D1CF',
            300: '#EB827E',
            400: '#DF5A54',
            500: '#CB3D37',
            600: '#AA302B',
            700: '#8D2B27',
            800: '#762926',
            900: '#3F1210',
          },
          accent: {
            orange: '#EEAB1D',
            'orange-bg': '#FFFBF1',
          },
          highlight: {
            growth: {
              300: '#B0CA70',
              500: '#7C963C',
            },
          },
          text: {
            main: '#203248',
            primary: '#203248',
            secondary: '#798491',
            tertiary: '#9FA5AC',
            white: '#FFFFFF',
            placeholder: '#CACBCD',
          },
          border: {
            cult: '#59554B',
          },
          cult: {
            black: '#302B1F',
            blue: '#E7F8FF',
          },
        },
      },
      keyframes: {
        'accordion-down': {
          from: { height: 0 },
          to: { height: 'var(--radix-accordion-content-height)' },
        },
        'accordion-up': {
          from: { height: 'var(--radix-accordion-content-height)' },
          to: { height: 0 },
        },
        levitate: {
          '0%, 100%': { transform: 'translateY(0)' },
          '50%': { transform: 'translateY(-10px)' },
        },
      },
      animation: {
        'accordion-down': 'accordion-down 0.2s ease-out',
        'accordion-up': 'accordion-up 0.2s ease-out',
        'spin-slow': 'spin 15s linear infinite',
        levitate: 'levitate 7s ease-in-out infinite',
      },
      boxShadow: {
        'benefit-card': '0px 2px 6px -2px rgba(91, 87, 82, 0.02)',
        'retail-card': '0px 2px 8px 0px rgba(0, 0, 0, 0.04)',
        card: '0px 4px 13px 0px rgba(0, 0, 0, 0.13)',
      },
    },
  },
  // eslint-disable-next-line import/no-extraneous-dependencies, global-require
  plugins: [import('@tailwindcss/forms'), import('tailwindcss-animate')],
};

export default config;
